import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { useSitemap } from 'wsm-common-data';
import { useIsMobile } from '../../hooks/useIsMobile';
import ContactFormFragment from './ContactFormFragment';

const ContactFormModal = ({ show, handleClose, staffMember }) => {
	const { isMobile } = useIsMobile();
	const sitemap = useSitemap();

	return (
		<div>
			<Modal
				show={show}
				onHide={handleClose}
				// d-flex in className + m-auto in dialogClassName centers modal in both x and y axes for desktop
				className={`contact-form-modal  ${
					isMobile ? 'modal dock-right no-slide' : 'd-flex'
				}`}
				dialogClassName={isMobile ? ' ' : 'm-auto'}
			>
				<Modal.Header closeButton style={{ borderBottom: 'none' }} />
				<div
					className="form-fragment-container"
					style={{ minHeight: 770 }}
				>
					<ContactFormFragment
						fragmentId="CONTACT_FORM"
						fragmentUrl={`${sitemap.get('STAFF_FORM')}?name=${
							staffMember.name
						}`}
					/>
				</div>
			</Modal>
		</div>
	);
};

// Define PropTypes
ContactFormModal.propTypes = {
	show: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
	staffMember: PropTypes.shape({
		name: PropTypes.string
	}).isRequired
};

export default ContactFormModal;
